import { ROLE_LABELS } from "./roles";
import type { Role } from "../api/types";
import { Badge } from "../ui/Badge";

/** A person's granted roles; Employee (everyone's base role) only when there are none. */
export function RoleBadges({ roles }: { roles: Role[] }) {
  const granted = roles.filter((role) => role !== "employee");
  if (granted.length === 0) {
    return <Badge>{ROLE_LABELS.employee}</Badge>;
  }
  return (
    <span className="badges">
      {granted.map((role) => (
        <Badge key={role} tone={role === "admin" ? "warning" : "primary"}>
          {ROLE_LABELS[role]}
        </Badge>
      ))}
    </span>
  );
}
